import React, { createContext, useContext, useState, useCallback } from 'react';

const ContactModalContext = createContext(null);

export const ContactModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    service: '',
    source: '',
    prefilledMessage: ''
  });

  const openModal = useCallback((data = {}) => {
    setFormData({
      service: data.service || '',
      source: data.source || '',
      prefilledMessage: data.prefilledMessage || ''
    });
    setIsOpen(true);
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    document.body.style.overflow = 'unset';
  }, []);

  return (
    <ContactModalContext.Provider value={{ isOpen, formData, openModal, openContactModal: openModal, closeModal }}>
      {children}
    </ContactModalContext.Provider>
  );
};

export const useContactModal = () => {
  const context = useContext(ContactModalContext);
  if (!context) {
    throw new Error('useContactModal must be used within a ContactModalProvider');
  }
  return context;
};
